<div
    id="add-object-map"
    class="add-object-map leaflet-map--block">
</div>
